
import agentSession, { simulatedAgentSession } from '../../../javascript/utils/agentSession';
import userSession from '../../../javascript/utils/userSession';
import { trackEvent } from '../../lib/analytics';

export const FETCH_OBJECTS_BEGIN = 'FETCH_OBJECTS_BEGIN';
export const FETCH_OBJECTS_SUCCESS = 'FETCH_OBJECTS_SUCCESS';
export const FETCH_OBJECTS_FAILURE = 'FETCH_OBJECTS_FAILURE';

export const SELECT_ALL_OBJECTS_BEGIN = 'SELECT_ALL_OBJECTS_BEGIN';
export const SELECT_ALL_OBJECTS_SUCCESS = 'SELECT_ALL_OBJECTS_SUCCESS';
export const SELECT_ALL_OBJECTS_FAILURE = 'SELECT_ALL_OBJECTS_FAILURE';

export const FETCH_OBJECT_FAILURE = 'FETCH_OBJECT_FAILURE';
export const UPDATE_SELECTED_COLUMNS = 'UPDATE_SELECTED_COLUMNS';
export const SELECT_OBJECTS = 'SELECT_OBJECTS';
export const UNSELECT_OBJECTS = 'UNSELECT_OBJECTS';
export const SET_CURRENT_TABLE_ID = 'SET_CURRENT_TABLE_ID';

export const SET_ORDER = 'SET_ORDER';
export const DROP_TABLE = 'DROP_TABLE';

import { setToolbarVisibility } from './currentCampaign';

export const fetchObjectsBegin = (opts) => ({
  type: FETCH_OBJECTS_BEGIN,
  opts
});

export const fetchObjectsSuccess = (data, opts) => ({
  type: FETCH_OBJECTS_SUCCESS,
  data,
  opts
});

export const fetchObjectsFailure = (error, opts) => ({
  type: FETCH_OBJECTS_FAILURE,
  error: error.message,
  opts
});

export const fetchObjectFailure = (error, opts) => ({
  type: FETCH_OBJECT_FAILURE,
  error: error.message,
  opts
});

export const selectAllObjectsSuccess = (data, opts) => ({
  type: SELECT_ALL_OBJECTS_SUCCESS,
  data,
  opts
});

export const selectAllObjectsFailure = (error, opts) => ({
  type: SELECT_ALL_OBJECTS_FAILURE,
  error: error.message,
  opts
});

export const selectAllObjectsBegin = (opts) => ({
  type: SELECT_ALL_OBJECTS_BEGIN,
  opts
});

export const fetchObjects = (opts = {}) => async (dispatch, getState) => {
  dispatch(fetchObjectsBegin(opts));
  const currentState = getState().tableOnSteroids[opts.tableId];
  const isAgentDashboard = opts.isAgentDashboard;
  const url = opts.url || currentState.url;
  const token = $('meta[name="csrf-token"]').attr('content');
  let query = opts.query || currentState.query;
  query = { ...query, ...(opts.extraParams || {}) };

  try {
    let headers = { 'X-CSRF-Token': token, 'Content-Type': 'application/json' };
    if (localStorage.getItem('token') != null && userSession('id') != null)
      headers.Authorization = `Bearer ${userSession('id')}:${localStorage.getItem('token')}`;
    if (localStorage.getItem('agentToken') != null && agentSession('id') != null && isAgentDashboard)
      headers.Authorization = `Bearer ${agentSession('id')}:${localStorage.getItem('agentToken')}`;

    headers['X-Simulated-Agent'] = simulatedAgentSession('id');

    const response = await fetch(url, {
      body: JSON.stringify(query),
      method: "POST",
      headers
    });
    const data = await response.json();
    await dispatch(fetchObjectsSuccess(data, opts));
    if (opts.callback) {
      opts.callback();
    }
  } catch (error) {
    dispatch(fetchObjectsFailure(error, opts));
    throw error;
  }
};

export const updateSelectedColumns = (selectedColumns, opts) => {
  trackEvent('Update Table Columns', 'Campaign Management', { selectedColumns });
  return ({
    type: UPDATE_SELECTED_COLUMNS,
    selectedColumns,
    opts
  });
};

export const addSelectedObject = (objects, opts) => ({
  type: SELECT_OBJECTS,
  objects,
  opts
});

export function selectObjects(objects, opts) {
  return (dispatch, getState) => {
    if (!opts || !opts.skipToolbar) {
      dispatch(setToolbarVisibility(true));
    }
    dispatch(addSelectedObject(objects, opts));
  };
}

export const unSelectObjects = (objects, opts) => ({
  type: UNSELECT_OBJECTS,
  objects,
  opts
});

export const unSelectAll = (opts) => ({
  type: UNSELECT_OBJECTS,
  all: true,
  opts,
});

export const setCurrentTableId = (tableId) => ({
  type: SET_CURRENT_TABLE_ID,
  tableId
});

export const selectAllObjects = (opts = {}) => async (dispatch, getState) => {
  dispatch(selectAllObjectsBegin(opts));
  let currentState = getState().tableOnSteroids[opts.tableId];
  let url = opts.url || currentState.url;
  let token = $('meta[name="csrf-token"]').attr('content');
  try {
    let headers = { 'X-CSRF-Token': token, 'Content-Type': 'application/json' };
    let params = opts['limit'] ? { all_pages: true, limit: opts['limit'] } : { all_pages: true } 
    if (opts['filters'] && Object.keys(opts['filters']).length > 0) {
      params = { ...params, ...opts['filters'] }
    }
    console.log(params);
    if (localStorage.getItem('token') != null && userSession('id') != null)
      headers.Authorization = `Bearer ${userSession('id')}:${localStorage.getItem('token')}`;
    const response = await fetch(url, {
      body: JSON.stringify(params),
      method: "POST",
      headers
    });
    const data = await response.json();
    await dispatch(selectAllObjectsSuccess(data, opts));
    if (opts.callback) {
      opts.callback();
    }
  } catch (error) {
    dispatch(selectAllObjectsFailure(error, opts));
    throw error;
  }
};

export const setOrder = ({ tableId, columnKey, ascending }) => ({
  type: SET_ORDER,
  opts: { tableId },
  columnKey,
  ascending
});

export const dropTable = ({ tableId }) => ({
  type: DROP_TABLE,
  opts: { tableId },
});
